// src/utils/faxTips.js
// Did you know? (3.83.0, owner, Nov 4): one of these shows under the welcome
// on the Overview, picked at random. `needs` is the permission it takes, so
// nobody reads about something their role can't do. Keep them true to the
// screens, say "your company", and no billing or fixed timings.
export const FAX_TIPS = [
  { text: 'You can send a fax by email, without opening the portal. It takes PDF and Word files.', needs: 'fax.emailToFax' },
  { text: 'Many failed faxes are retried by the portal itself. Check the Outbox before you resend.', needs: 'tab.outgoing' },
  { text: 'Click a fax in the Outbox to see its preview and every try in its History.', needs: 'tab.outgoing' },
  { text: 'In Compose, you can schedule a fax to go out later.', needs: 'fax.send' },
  { text: 'Compose warns you when a fax number often fails, before you send.', needs: 'fax.send' },
  { text: 'Give a fax number a name in Contacts, and it shows under the number in your Outbox and Inbox.', needs: 'tab.contacts' },
  { text: 'Logs → Problem numbers lists fax numbers that often fail, so you can check a number first.', needs: 'logs.problemNumbers' },
  { text: 'Users → Sending activity shows who sends faxes, by portal or email.', needs: 'sending.view' },
  { text: 'Automatic retries go out in your company’s office hours. You can set them in Settings → Office Hours.', needs: 'settings.officeHours' },
  { text: 'The Library has short articles and videos on everything in the portal.', needs: 'tab.kb' },
  { text: 'A fax to a number that’s already taking a call waits in line and goes out by itself.', needs: 'tab.outgoing' },
  { text: 'Compose can add a cover sheet, with a message you can format.', needs: 'fax.send' },
  { text: 'You can see who at your company opened each received fax.', needs: 'inbox.seenBy' },
  { text: 'The search box on this page finds a fax by number, contact or sender.' },
  { text: 'Use Arrange on this page to put the cards and sections where you want them.' },
  { text: 'On a computer, press ? to see the keyboard shortcuts.' },
  { text: 'You can change the portal’s colours, and switch between light and dark, at the top of the page.' },
  { text: 'The bell shows your fax news from the last 7 days.' },
  { text: 'Something not working? Help → Report a bug sends it straight to Fax Portal support.' },
  { text: 'My notes keeps your own notes in the portal, with reminders.' },
  { text: 'On a device with Face ID or a fingerprint, you can open the portal without typing your password.' },
];

// 3.83.1 (owner): the apps come up more often than the rest, one time in three
const APPS_TIP = 'You can install the Fax Portal as an app: open Resources, then Apps.';

export const randomTip = can => {
  if (Math.random() < 1 / 3) return APPS_TIP;
  const list = FAX_TIPS.filter(t => !t.needs || can(t.needs));
  return list[Math.floor(Math.random() * list.length)]?.text || '';
};
